export default "<div>\r\n    <span class=\"clock   pl-2 pr-2\"> <span *ngIf=\"showFirstTime\">{{firstTime}}</span>{{hour}}</span>\r\n  </div>\r\n  \r\n"